import React, { useMemo } from 'react';
import { forecastedClientsColumns } from './columns';
import Table from '../../../components/table/table';
import useCompanies from '../../../hooks/useCompanies';

const ForecastedClients = ({ projects, filtersRange }) => {
  const { companies } = useCompanies();
  const companiesMap = useMemo(() => {
    if (!companies) return {};
    return companies.reduce((map, company) => {
      map[company.companyID] = company.companyName;
      return map;
    }, {});
  }, [companies]);

  const monthlyTotals = useMemo(() => {
    return filtersRange.map((month) => {
      return projects
        .reduce((sum, project) => {
          const value = project.formattedSchedule.find((x) => x.date === month)?.value || 0;
          return sum + value;
        }, 0)
        .toFixed(2);
    });
  }, [projects, filtersRange]);

  const clientsSum = projects.reduce((acc, project) => {
    if (!acc[project.client]) {
      acc[project.client] = filtersRange.reduce((acc, month) => ({ ...acc, [month]: 0 }), {});
    }

    project.formattedSchedule.forEach((scheduleItem) => {
      if (filtersRange.includes(scheduleItem.date)) {
        acc[project.client][scheduleItem.date] += scheduleItem.value;
      }
    });
    return acc;
  }, {});

  const dataToRender = Object.keys(clientsSum).map((id) => {
    return {
      id,
      clientName: companiesMap[id] || '',
      schedule: clientsSum[id],
      clientTotal: Object.values(clientsSum[id]).reduce((sum, val) => sum + val, 0),
    };
  });

  return (
    <div className="forecasted-table">
      <Table
        data={dataToRender}
        columns={forecastedClientsColumns(filtersRange, monthlyTotals, dataToRender)}
        hasFooter={true}
        stickyHeader={true}
        rowBackground="white"
        rowHover={true}
        useUniformBackground={true}
      />
    </div>
  );
};

export default ForecastedClients;
